// What the material card's corner badge says. pbr/toon/skin rows are the
// deprecated backups the migration leaves behind (spec §C step 4); a person
// scanning the grid must be able to tell them from the live graph rows.
const LEGACY = new Set(['pbr', 'toon', 'skin'])
export function materialBadge(type) {
  if (!type) return '?'
  return LEGACY.has(type) ? 'LEGACY' : String(type).toUpperCase()
}
